<!-- 产品滑块 -->
<!-- author: niming175 -->
<template>
  <div
    class="product-swiper"
    :class="{
      'product-swiper--show-nav': showNavButton,
      'product-swiper--left': paginationStyle === 'left',
    }"
  >
    <!-- 分页居左 -->
    <div class="product-swiper__left-pagination" v-if="gallery.length > 1 && paginationStyle === 'left'">
      <!-- 居左分页 -->
      <vertical-pagination class="left-pagination" :data="gallery" v-model="swiperIndex" />
    </div>

    <!-- swiper -->
    <div class="product-swiper__wrapper">
      <!-- 产品标签 -->
      <v-product-tag
        v-if="productTagData"
        :productTag="productTagData"
        :productInfo="productInfo"
        class="product-swiper__tag"
      />

      <!-- 图片切换 -->
      <media-swiper
        ref="swiper"
        :options="swiperOptions"
        :data="gallery"
        v-model="swiperIndex"
        :enable-pic-zoom="enablePicZoom || null"
        :show-nav-button="showNavButton"
        rowKey="ID"
        @change="handleChange"
        @endChange="handleEndChange"
      />
    </div> 

    <!-- 显示分页 -->
    <!-- 图片小于2张，不显示分页 -->
    <div
      class="product-swiper__pagination"
      :class="[`product-swiper__${paginationStyle}-pagination`]"
      v-if="gallery.length > 1 && ['dot', 'list', 'inline', 'number'].includes(paginationStyle)"
    >
      <!-- 点状分页, 移动端显示 -->
      <div class="dot-pagination" v-if="paginationStyle === 'dot'">
        <span
          v-for="(i, index) in gallery.length"
          :class="{
            active: swiperIndex === index,
          }"
          :key="i"
          @click="() => (swiperIndex = index)"
        />
      </div>

      <!-- 罗列分页 -->
      <div class="list-pagination" v-else-if="paginationStyle === 'list'">
        <span
          class="list-pagination__item"
          v-for="(item, index) in gallery"
          :key="item.ID"
          :class="{
            active: swiperIndex === index,
          }"
          @click="() => selectSwiper(index)"
        >
          <div class="list-pagination__img-wrapper">
            <i
              v-if="item.media_content_type === 'external_video' || item.media_content_type === 'video'"
              class="list-pagination__video-icon"
              :class="{
                'iconfont icon-cm-youtube': item.media_content_type === 'external_video',
                'el-icon-video-play': item.media_content_type === 'video',
              }"
            />
            <v-lazy-img :src="item.thumbnail" :data-url="item.url" />
          </div>
        </span>
      </div>

      <!-- 数字 -->
      <div class="number-pagination" v-else-if="paginationStyle === 'number'">
        <span>
          {{ activeIndex + 1 }}
        </span>
        <span>/</span>
        <span>
          {{ gallery.length }}
        </span>
      </div>

      <!-- 横版分页 -->
      <media-swiper
        ref="thumbSwiper"
        v-else
        class="inline-pagination"
        type="thumb"
        rowKey="ID"
        v-model="swiperIndex"
        :options="thumbSwiperOption"
        :data="gallery"
        :show-nav-button="true"
        :nav-animation="true"
      />
    </div>
  </div>
</template>

<script>
import { playVideo } from '@/js/lib/util'
//import LazyImg from '@/js/components/LazyImg.vue'
import MediaSwiper from './MediaSwiper.vue'
import VerticalPagination from './VerticalPagination.vue'
import vProductTag from '@/js/components/view/productTag/productTag.vue'
import { mapState } from 'vuex'

export default {
  components: {
    //LazyImg,
    MediaSwiper,
    VerticalPagination,
    vProductTag,
  },
  props: {
    // 切换的图片
    gallery: {
      type: Array,
      require: true,
    },
    // 放大镜功能
    enablePicZoom: {
      type: Boolean,
      default: null,
    },
    // 分页类型，list，inline, dot 或 null
    paginationStyle: {
      type: String,
      default: null,
      validator: (val) => {
        return ['list', 'inline', 'dot', 'left', 'number'].includes(val)
      },
    },
    productRes: {
      type: Object,
      default: null,
    },
    // 是否展示产品卡片标签
    isProduct: {
      type: Boolean | String,
      default: false,
    },
    // swiper配置
    option: {
      type: Object,
      default: null,
    },
    swiper_index: {
      type: Object,
      default: null,
    },
    // 是否展示导航箭头按钮，就是向左向右按钮
    showNavButton: {
      type: Boolean,
      default: false,
    },
    productInfo: {
      type: Object,
      default: null,
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
  },
  model: {
    prop: 'activeIndex',
    event: 'change',
  },
  emits: ['change'],
  data() {
    const defaultOption = {
      autoHeight: true, // enable auto height
      // 循环
      loop: true,
      noSwiping: true,
      noSwipingClass: 'swiper-no-swiping',
    }

    if (this.showNavButton) {
      // 左右切换按钮
      defaultOption.navigation = {
        nextEl: '.media-swiper__next',
        prevEl: '.media-swiper__prev',
      }
    }

    const option = this.option || defaultOption

    return {
      // defaultImage,
      swiperOptions: {
        ...option,
        autoHeight: true,
        autoplay:
          this.autoplay && this.gallery?.length > 1
            ? {
                delay: 4000,
                disableOnInteraction: false,
              }
            : false,
      },
      // 缩略图
      thumbSwiperOption: {
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 12,
        freeMode: true,
        updateOnWindowResize: true,
        navigation: {
          nextEl: '.media-swiper__next',
          prevEl: '.media-swiper__prev',
        },
        allowTouchMove: false,
        centeredSlides: false,
        normalizeSlideIndex: false,
        slideToClickedSlide: true,
        touchRatio: 0.2,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      },
      el: null,
      swiperIndex: 0, // 从0开始，swiper的index是从1开始
      autoPlayVideo: !this.autoplay, // 自动播放视频
    }
  },
  methods: {
    /**
     * 滚动
     */
    handleChange(index) {
      const videoDom = this.el && Jq(this.el)?.find('.swiper-slide-active [video-src]')?.[0]

      if (videoDom) {
        playVideo(videoDom, 0)
      }
      
      if (index !== this.activeIndex) {
        this.$emit('change', index)
      }
    },
    /**
     * 结束切换
     * 如果切换到的是视频的话，则播放视频
     * 开启自动轮播的情况：
     * 播放视频，停止自动轮播，
     * 普通图片，继续轮播
     */
    handleEndChange(a) {
      const videoDom = this.el && Jq(this.el)?.find('.swiper-slide-active [video-src]')?.[0]

      if (videoDom) {
        playVideo(videoDom, 1)

        if (this.autoplay) {
          this.swiper.play(false)
        }
      } else {
        if (this.autoplay) {
          this.swiper.play(true)
        }
      }
    },
    /**
     * 切换swiper
     */
    selectSwiper(index) {
      this.swiperIndex = index
    },
  },
  computed: {
    swiper() {
      return this.$refs.swiper
    },
    thumbSwiper() {
      return this.$refs.thumbSwiper
    },
    ...mapState({
      productTagData({product_tag_list}) {
        if (this.isProduct && this.productRes?.ID) {
          return product_tag_list[this.productRes.ID] ?? null
        }

        return null
      }
    })
  },
  mounted() {
    const dom = this.swiper.$el

    if (this.activeIndex > 0) {
      this.swiper?.slideTo(this.activeIndex)
    }

    this.el = dom
    // 先关闭已经正在播放的视频如果有的话
    const videoDom = Jq('.product-swiper .swiper-slide.swiper-slide-active [video-src]')

    if (videoDom && videoDom.length > 0) {
      for (let i = 0; i < videoDom.length; i++) {
        playVideo(videoDom[i], 0)
      }
    }

    // 当前可能是视频需要播放
    const thisVideoDom = dom && Jq(dom)?.find('.swiper-slide-active [video-src]')?.[0]

    if (thisVideoDom) {
      // 播放视频
      playVideo(thisVideoDom, 1)

      // 如果设置了自动轮播，则要停止轮播
      if (this.autoplay) {
        this.swiper.play(false)
      }
    }
  },
  watch: {
    activeIndex(newIndex) {
      this.swiperIndex = newIndex
    }
  },
}
</script>
<style lang='scss' scoped>
.product-swiper {
  max-width: 100vw;
  position: relative;
  // 轮播图
  margin-bottom: 60px;
  .media-swiper {
    width: 100%;
  }
  &--show-nav {
    .product-swiper {
      &__tag {
        left: calc(5% + 48px);
        width: calc(90% - 96px);
        display: inline-block;
      }
    }
    &::v-deep {
      .swiper {
        width: calc(90% - 96px);
        .swiper-button-prev,
        .swiper-button-next 
        {
          background-image: none;
          font-size: 34px;
          color: #ababab;
          font-weight: 100;
          height: 44px;
          line-height: 44px;
        }
      }
      .media-swiper {
        &__prev,
        &__next {
          background-image: none;
          font-size: 34px;
          color: #ababab;
          font-weight: 100;
        }
      }
    }
  }
  &__pagination {
    margin-top: 20px;
    .list-pagination {
      margin-left: -6px;
      margin-right: -6px;
      text-align: center;
      &__item {
        display: inline-block;
        padding-left: 6px;
        padding-right: 6px;
        padding-top: 3px;
        padding-bottom: 3px;
        &.active {
          .list-pagination {
            &__img-wrapper {
              &::before {
                border: 2px solid var(--main-btn-bg);
              }
            }
          }
        }
      }
      &__img-wrapper {
        height: 50px;
        width: 50px;
        cursor: pointer;
        position: relative;
        background-color: #dedede5d;
        &::before {
          height: 100%;
          width: 100%;
          position: absolute;
          top: 0;
          content: '';
          z-index: 2;
        }
        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }
      &__video-icon {
        position: absolute;
        z-index: 2;
        font-size: 18px;
        color: #fff;
        height: 100%;
        width: 100%;
        background: #00000035;
        top: 0;
        left: 0;
        &::before {
          position: absolute;
          right: 6px;
          bottom: 6px;
        }
      }
    }
    .inline-pagination {
      ::v-deep {
        .swiper-slide {
          height: 64px;
          width: 64px;
        }
      }
    }
    .dot-pagination {
      width: 100%;
      text-align: center;
      padding-left: 15px;
      padding-right: 15px;
      position: absolute;
      bottom: 10px;
      z-index: 3;
      span {
        display: inline-block;
        height: 10px;
        width: 10px;
        border-radius: 50%;
        background-color: #fff;
        opacity: 0.2;
        margin: 0 4px;
        overflow: hidden;
        line-height: 14px;
        &.active {
          opacity: 1;
          background-color: #f5a503;
        }
      }
    }
  }
  &__number-pagination {
    position: absolute;
    top: 10px;
    right: 15px;
    display: inline-block;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50vh;
    padding: 0px 15px;
    margin-top: 0px;
    line-height: 20px;
    color: #fff;
    z-index: 3;
    font-size: 14px;
  }
  // 分页居左
  &--left {
    display: flex;
    width: 100%;
    min-height: 500px;
    max-width: 100vw;
    .product-swiper {
      &__wrapper {
        flex: 1;
        position: relative;
        // width: calc(100% - 120px);
        overflow: hidden;
      }
    }
  }
  &__left-pagination {
    width: 100px;
    margin-right: 20px;
    position: relative;
    .left-pagination {
      position: absolute;
      height: 100%;
    }
  }

  @media screen and (max-width: 767px) {
    margin-bottom: 0;
    &__slide-card,
    &__tag {
      width: 100%;
    }
    ::v-deep {
      .media-swiper {
        &__slide-card {
          img {
            width: 100%;
          }
        }
      }
    }
    &__tag {
      left: 0;
    }
    &--show-nav {
      .product-swiper {
        &__slide-card,
        &__tag {
          width: 100%;
        }
        &__tag {
          left: 0;
        }
      }
      &::v-deep {
        .swiper {
          .swiper-button-prev,
          .swiper-button-next {
            display: none;
          }
        }
      }
    }
    &__pagination {
      .media-swiper {
        display: none;
      }
    }
  }
}
</style>
